export default __webpack_public_path__ + "static/media/title-graphic.5ad2725a.svg";